import { Typography } from '@mui/material';
import { differenceInDays, intervalToDuration } from 'date-fns';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var formatTime = function formatTime(time) {
  return time > 9 ? "".concat(time) : "0".concat(time);
};

var getExpirationTime = function getExpirationTime(expirationDate) {
  var _duration$hours, _duration$minutes, _duration$seconds;

  var endDate = new Date(expirationDate);
  var now = new Date();
  var totalDays = differenceInDays(endDate, now);
  var duration = intervalToDuration({
    start: now,
    end: endDate
  });
  var days = totalDays > 0 ? "".concat(totalDays, " days ") : '';
  var hh = formatTime((_duration$hours = duration.hours) !== null && _duration$hours !== void 0 ? _duration$hours : 0);
  var mm = formatTime((_duration$minutes = duration.minutes) !== null && _duration$minutes !== void 0 ? _duration$minutes : 0);
  var ss = formatTime((_duration$seconds = duration.seconds) !== null && _duration$seconds !== void 0 ? _duration$seconds : 0);
  return "".concat(days).concat(hh, ":").concat(mm, ":").concat(ss, " hours");
};

export function ExpirationTime(_ref) {
  var expirationDate = _ref.expirationDate;

  var _useState = useState(),
      expirationTime = _useState[0],
      setExpirationTime = _useState[1];

  useEffect(function () {
    setExpirationTime(getExpirationTime(expirationDate));
    var intervalId = setInterval(function () {
      return setExpirationTime(getExpirationTime(expirationDate));
    }, 1000);
    return function () {
      return clearInterval(intervalId);
    };
  }, []);
  return expirationDate ? /*#__PURE__*/_jsxs(Typography, {
    sx: {
      m: 0.5
    },
    variant: "body2",
    children: ["Ends in ", /*#__PURE__*/_jsx("b", {
      children: expirationTime
    })]
  }) : null;
}